import {Component, ElementRef, HostListener, Injectable, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {BehaviorSubject, Observable, of as observableOf, Subject} from 'rxjs';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {ExternalItem, FlowChartNode, FlowChartUiFlatNode} from '../../../models/data-survey.models';
import {IFlowChartDataService} from '../../../services/flow-chart-data.service';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {take, takeUntil} from 'rxjs/operators';
import {FieldDefinition} from '@shared/models/field-definition';
import {Guid} from 'guid-typescript';
import {FieldEditorDialogModel} from '@shared/models/field-editor.model';
import {SmartGridService} from '@core/services/smart-grid.service';
import {Configuration} from '@shared/models/configuration';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {FuseSidebarService} from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Router} from '@angular/router';
import {
  SetCurrentRightSideBarFoldOrNotAction,
  SetCurrentRightSideComponentAction,
  SetCurrentViewDetailAction
} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {select, Store} from '@ngrx/store';
import {DetailsInstructionService, InstructionDetailsSourceViewType} from '@shared/services/details-instruction-service';
import {EatFlowChartService} from '../../../services/eat-flow-chart.service';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {GetSmartGridFieldSectionInfosAction} from '@shared/store/actions/smart-grid.actions';
import {GetFieldSectionsAction} from '@shared/store/actions/virtual-grid.actions';
import {MenuConfig} from '@features/data-survey/models/flow-chart.model';
import {PlatformSidebarService} from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {MatMenuTrigger} from '@angular/material/menu';
import {Api} from "@shared/constants/common-field.constants";
import { SnippetViewType } from '@features/data-survey/models/snippet-view-type';
import {XatBotThreadService} from "@features/xatbot/services/xat-bot-thread.service";


@Component({
    standalone: false,
    selector: 'particle-flow-chart-designer',
  templateUrl: './flow-chart-designer.component.html',
  styleUrls: ['./flow-chart-designer.component.scss'],
})
export class FlowChartDesignerComponent implements OnInit, OnDestroy {
  @Input() flowChartDataService: IFlowChartDataService;
  @Input() section: any;
  @Input() tabData: any;
  @Input() sourceType: string;
  @Input() flowchart: any;
  @Input() menuConfig: MenuConfig;
  @Input() showFieldKey: boolean;
  @ViewChild('matMenu') matMenuTrigger: MatMenuTrigger;
  isManageFields = false;
  isFieldSchema = false;
  allowedActions: any;
  hasCheckbox = false;
  snippetView: typeof SnippetViewType = SnippetViewType;


  constructor(private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private eatFlowChartService: EatFlowChartService,
              private smartGridService: SmartGridService,
              private dialogService: DialogService,
              private commandService: CommandService,
              private particleCacheService: ParticleCacheService,
              private eRef: ElementRef,
              private router: Router,
              private queryState: Store<IQueryState>,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private platformSidebarService: PlatformSidebarService,
              private sidebarService: FuseSidebarService,
              private detailsInstructionService: DetailsInstructionService,
              private xatBotThreadService: XatBotThreadService) {

    this.treeFlattener = new MatTreeFlattener(this.transformer, this._getLevel,
      this._isExpandable, this._getChildren);
    this.treeControl = new FlatTreeControl<FlowChartUiFlatNode>(this._getLevel, this._isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataChange.pipe(takeUntil(this.unsubscribe$)).subscribe(data => this.rebuildTreeForData(data));
    this.allowedActions = {};
  }

  get data(): FlowChartNode[] {
    return this.dataChange.value;
  }

  treeControl: FlatTreeControl<FlowChartUiFlatNode>;
  treeFlattener: MatTreeFlattener<FlowChartNode, FlowChartUiFlatNode>;
  dataSource: MatTreeFlatDataSource<FlowChartNode, FlowChartUiFlatNode>;
  expandedNodeSet = new Set<string>();
  dragging = false;
  isDragDisabled = false;
  expandTimeout: any;
  expandDelay = 1000;

  selectedNodeId = '';

  dataTypeConfig: any;
  unsubscribe$ = new Subject<void>();
  flowChartControlPanel: any = {isMoveLeft: false, isMoveRight: false, isMoveUp: false, isMoveDown: false};
  /** SHAON */
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<FlowChartUiFlatNode, FlowChartNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<FlowChartNode, FlowChartUiFlatNode>();

  /** SHAON */

    ////////////////////////////////////// TreeBuild//////////////////////////
  dataChange = new BehaviorSubject<FlowChartNode[]>([]);
  lastAddedFieldKey: string;

  // addedFieldSection: any;

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  /** SHAON */

  transformer = (node: FlowChartNode, level: number) => {
    // return new FileFlatNode(!!node.children, node.filename, level, node.type, node.id);

    /** SHAON */
    const existingNode = this.nestedNodeMap.get(node);
    /* const flatNode = existingNode && existingNode.item.title === node.title
       ? existingNode
       : new FlowChartUiFlatNode(!!node.children, level, node.id,node);*/
    node.isHidden = node.isHidden || node.isParentHidden;
    const flatNode = new FlowChartUiFlatNode(!!node.children, level, node.id, node);
    flatNode.level = level;
    flatNode.expandable = node.children.length > 0;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
    /** SHAON */
  }
  private _getLevel = (node: FlowChartUiFlatNode) => node.level;
  private _isExpandable = (node: FlowChartUiFlatNode) => node.expandable;
  private _getChildren = (node: FlowChartNode): Observable<FlowChartNode[]> => observableOf(node.children);
  hasChild = (_: number, _nodeData: FlowChartUiFlatNode) => _nodeData.item.children.length > 0;


  /**
   * This constructs an array of nodes that matches the DOM,
   * and calls rememberExpandedTreeNodes to persist expand state
   */
  visibleNodes(): FlowChartNode[] {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    const result = [];

    function addExpandedChildren(node: FlowChartNode, expanded: Set<string>) {
      result.push(node);
      if (expanded.has(node.id)) {
        node.children.map(child => addExpandedChildren(child, expanded));
      }
    }

    this.dataSource.data.forEach(node => {
      addExpandedChildren(node, this.expandedNodeSet);
    });
    return result;
  }

  /**
   * Handle the drop - here we rearrange the data based on the drop event,
   * then rebuild the tree.
   * */
  drop(event: CdkDragDrop<string[]>) {
    // console.log('origin/destination', event.previousIndex, event.currentIndex);

    // ignore drops outside of the tree
    if (!event.isPointerOverContainer) {
      return;
    }
    if (!this.flowChartDataService.excludeHiddenQuestions) {
      this.snackBarService.showInformation('Re-ordering is disabled while excluded item are visible. Turn off \'Show Excluded Items\'');
      return;
    }

    // construct a list of visible nodes, this will match the DOM.
    // the cdkDragDrop event.currentIndex jives with visible nodes.
    // it calls rememberExpandedTreeNodes to persist expand state
    const visibleNodes = this.visibleNodes();

    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));

    // recursive find function to find siblings of node
    function findNodeSiblings(arr: Array<any>, id: string): Array<any> {
      let result, subResult;
      arr.forEach(item => {
        if (item.id === id) {
          result = arr;
        } else if (item.children) {
          subResult = findNodeSiblings(item.children, id);
          if (subResult) {
            result = subResult;
          }
        }
      });
      return result;
    }

    // remove the node from its old place (For immediate reflect at UI)
    const node = event.item.data;
    const siblings = findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    const nodeToInsert: FlowChartNode = siblings.splice(siblingIndex, 1)[0];

    // checking only visible tree nodes.
    const flatChangedData = this.treeControl.dataNodes.filter(fnode => {
      const isVisible = document.getElementById(fnode.id);
      return isVisible;
    });
    const prevIndex = flatChangedData.findIndex(n => n.id === node.id);
    if (prevIndex == event.currentIndex) {
      return;
    }
    const immediateNodeIndex = event.currentIndex > prevIndex ? event.currentIndex : event.currentIndex - 1;

    let immediateFlatNode = null;
    let currentSiblings = [];
    let relativeIndex = 0;
    let isInsertFirst;
    if (immediateNodeIndex >= 0) {
      const immediateNode = flatChangedData[immediateNodeIndex];
      immediateFlatNode = this.treeControl.dataNodes.find((x: any) => x.id == immediateNode.id);
      isInsertFirst = this.treeControl.isExpanded(immediateFlatNode) && immediateNode.item.children.length > 0;
      if (!immediateFlatNode) {
        immediateFlatNode = null;
      }
      currentSiblings = this.findNodeSiblings(changedData, immediateNode.id);
      relativeIndex = currentSiblings.findIndex(n => n.id === immediateNode.id);
      relativeIndex = relativeIndex + 1;
    } else {
      relativeIndex = 0;
    }
    let parent = this.getParentNode(immediateFlatNode);
    if (isInsertFirst) {
      parent = immediateFlatNode;
      relativeIndex = 0;
    }


    // insert node
    // const newSiblings = findNodeSiblings(changedData, nodeAtDest.id);
    // if (!newSiblings) { return; }
    // const nodeAtDestSiblingIndex = siblings.findIndex(n => n.id === nodeAtDest.id);
    // if(nodeAtDestSiblingIndex>0)newSiblings.splice(nodeAtDestSiblingIndex, 0, nodeToInsert);
    this.fuseSplashScreenService.show();

//// save changes to server
    // let newOrder = event.previousIndex<event.currentIndex?event.currentIndex-1:event.currentIndex;
    this.moveMoveFlowchartQuestion(nodeToInsert.id, this.section.id, parent ? parent.item.id : '', nodeToInsert.sourceSectionId, relativeIndex, false);
///// save///////////////
    // rebuild tree with mutated data
    // perform
    this.rebuildTreeForData(changedData);
  }

  /**
   * Experimental - opening tree nodes as you drag over them
   */
  dragStart() {
    this.dragging = true;
  }

  dragEnd() {
    this.dragging = false;
  }

  dragHover(node: FlowChartUiFlatNode) {
    if (this.dragging) {
      console.log('drag node');
      console.log(node);
      clearTimeout(this.expandTimeout);
      this.expandTimeout = setTimeout(() => {
        this.treeControl.expand(node);
      }, this.expandDelay);
    }
  }

  dragHoverEnd() {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
    }
  }

  /**
   * The following methods are for persisting the tree expand state
   * after being rebuilt
   */

  rebuildTreeForData(data: any) {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    this.dataSource.data = data;
    this.forgetMissingExpandedNodes(this.treeControl, this.expandedNodeSet);
    this.expandNodesById(this.treeControl.dataNodes, Array.from(this.expandedNodeSet));
    this.validateFlowChartControlPanel();
    this.expandAllNodes();
  }

  private expandAllNodes() {
    this.treeControl.dataNodes.forEach((node) => {
      this.treeControl.expand(node);
      let parent = this.getParentNode(node);
      while (parent) {
        this.treeControl.expand(parent);
        parent = this.getParentNode(parent);
      }
    });
  }

  private rememberExpandedTreeNodes(
    treeControl: FlatTreeControl<FlowChartUiFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      treeControl.dataNodes.forEach((node) => {
        if (treeControl.isExpandable(node) && treeControl.isExpanded(node)) {
          // capture latest expanded state
          expandedNodeSet.add(node.id);
        }
      });
    }
  }
  getMatTreeNodePadding(node: any): number {
    return node.level * 30;
  }
  private forgetMissingExpandedNodes(
    treeControl: FlatTreeControl<FlowChartUiFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      expandedNodeSet.forEach((nodeId) => {
        // maintain expanded node state
        if (!treeControl.dataNodes.find((n) => n.id === nodeId)) {
          // if the tree doesn't have the previous node, remove it from the expanded list
          expandedNodeSet.delete(nodeId);
        }
      });
    }
  }

  private expandNodesById(flatNodes: FlowChartUiFlatNode[], ids: string[]) {
    if (!flatNodes || flatNodes.length === 0) {
      return;
    }
    const idSet = new Set(ids);
    return flatNodes.forEach((node) => {
      if (idSet.has(node.id)) {
        this.treeControl.expand(node);
        let parent = this.getParentNode(node);
        while (parent) {
          this.treeControl.expand(parent);
          parent = this.getParentNode(parent);
        }
      }
    });
  }

  private getParentNode(node: FlowChartUiFlatNode): FlowChartUiFlatNode | null {
    if (node == null) {
      return null;
    }
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  ngOnInit(): void {
    this.initialize();
  }

  onSelectionChange($event, node: any) {
    console.log('event:', $event);
    this.updateChecklist(node.item, $event.checked);
  }

  /** SHAON */
  hasNoContent = (_: number, _nodeData: FlowChartUiFlatNode) => _nodeData.item.title === '';

  onSelectedNode(node: any) {
    //this.platformSidebarService.openActivityFeedByReferenceCode(node.item.id, node.item.title, true, false);
    this.selectedNodeId = node.item.id;
    this.validateFlowChartControlPanel();
  }

  triggerForMatMenu(node) {
    this.onSelectedNode(node);
    setTimeout(() => {
      this.matMenuTrigger?.openMenu();
    }, 2000);
  }


  private validateFlowChartControlPanel() {
    const selectedNode = this.treeControl.dataNodes.find(x => x.id == this.selectedNodeId);
    if (selectedNode) {
      this.flowChartControlPanel.isMoveUp = this.isMoveUp(selectedNode);
      this.flowChartControlPanel.isMoveDown = this.isDown(selectedNode);
      this.flowChartControlPanel.isMoveLeft = this.isMoveLeft(selectedNode);
      this.flowChartControlPanel.isMoveRight = this.isMoveRight(selectedNode);
    }

  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.dialogService.dialogStack.length) {
      return;
    }
    if (this.eRef.nativeElement.contains(event.target)) {
      // "clicked inside";
    } else {
      this.selectedNodeId = '';
      this.flowChartControlPanel.isMoveUp = false;
      this.flowChartControlPanel.isMoveDown = false;
      this.flowChartControlPanel.isMoveLeft = false;
      this.flowChartControlPanel.isMoveRight = false;
    }
  }

  getAutoSelectedQuestionIndex(fieldKey: any, node: FlowChartUiFlatNode) {
    let index;
    if (fieldKey) {
      index = this.treeControl.dataNodes.findIndex(n => n.item.fieldKey === fieldKey);
    } else {
      const changedData = JSON.parse(JSON.stringify(this.dataSource.data));
      const siblings = this.findNodeSiblings(changedData, node.id);
      const currentNodeIndex = siblings.findIndex(n => n.id === node.id && node.item.isHidden === false);
      if (currentNodeIndex === 0) {
        const parent = this.getParentNode(node);
        if (parent) {
          index = this.treeControl.dataNodes.findIndex(n => n.id === parent.id);
        } else {
          index = 0;
        }
      } else {
        const s = siblings[currentNodeIndex - 1];
        index = this.treeControl.dataNodes.findIndex(n => n.id === s.id && node.item.isHidden === false);
      }
    }
    if (index < 0) {
      return -1;
    }
    return index;
  }

  /** Select the category so we can insert the new item. */


  findNodeSiblings(arr: Array<any>, id: string): Array<any> {
    let result, subResult;
    if (id == null) {
      return arr;
    }
    arr.forEach(item => {
      if (item.id === id) {
        result = arr;
      } else if (item.children) {
        subResult = this.findNodeSiblings(item.children, id);
        if (subResult) {
          result = subResult;
        }
      }
    });
    return result;
  }

  isMoveUp(node: FlowChartUiFlatNode) {
    const parent = this.getParentNode(node);
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));
    const siblings = this.findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    if (siblingIndex - 1 < 0) {
      return false;
    }
    return true;
  }

  isDown(node: FlowChartUiFlatNode) {
    const parent = this.getParentNode(node);
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));
    const siblings = this.findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    const nodeToInsert: FlowChartNode = siblings.splice(siblingIndex, 1)[0];
    if (siblingIndex + 1 > siblings.length) {
      return false;
    }
    return true;
  }

  isMoveRight(node: FlowChartUiFlatNode) {
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));
    const siblings = this.findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    let parent: FlowChartNode = null;
    if (siblings[siblingIndex - 1]) {
      parent = siblings[siblingIndex - 1];
    }
    if (!parent) {
      return false;
    }
    return true;
  }

  isMoveLeft(node: FlowChartUiFlatNode) {
    const parent = this.getParentNode(node);
    if (!parent) {
      return false;
    }
    return true;
  }

  moveUp(node: FlowChartUiFlatNode) {
    const parent = this.getParentNode(node);
    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));
    // recursive find function to find siblings of node
    const siblings = this.findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    const nodeToInsert: FlowChartNode = siblings.splice(siblingIndex, 1)[0];
    if (siblingIndex - 1 < 0) {
      return false;
    }
    const newOrder = siblingIndex - 1;
    let pId = '';
    if (parent) {
      pId = parent.id;
    }
    this.moveMoveFlowchartQuestion(nodeToInsert.id, this.section.id, pId, nodeToInsert.sourceSectionId, newOrder);

  }

  moveDown(node: FlowChartUiFlatNode) {
    const parent = this.getParentNode(node);
    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));
    // recursive find function to find siblings of node
    const siblings = this.findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    const nodeToInsert: FlowChartNode = siblings.splice(siblingIndex, 1)[0];
    if (siblingIndex + 1 > siblings.length) {
      return false;
    }
    const newOrder = siblingIndex + 1;
    let pId = '';
    if (parent) {
      pId = parent.id;
    }
    this.moveMoveFlowchartQuestion(nodeToInsert.id, this.section.id, pId, nodeToInsert.sourceSectionId, newOrder);
  }

  moveRight(node: FlowChartUiFlatNode) {
    if(this.flowChartDataService?.fieldValues?.IsAutoGeneratedFile){
      this.snackBarService.showWarning('You can not convert a parent field to a subfield in auto generated QNRs');
      return;
    }
    if (this.isManageFields) {
      return;
    }
    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));
    // recursive find function to find siblings of node
    const siblings = this.findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    const nodeToInsert: FlowChartNode = siblings.splice(siblingIndex, 1)[0];
    let parent: FlowChartNode = null;
    if (siblings[siblingIndex - 1]) {
      parent = siblings[siblingIndex - 1];
    }
    if (!parent) {
      return false;
    }
    const newOrder = parent.children.length;
    this.moveMoveFlowchartQuestion(nodeToInsert.id, this.section.id, parent.id, nodeToInsert.sourceSectionId, newOrder);

  }

  moveLeft(node: FlowChartUiFlatNode) {
    if(this.flowChartDataService?.fieldValues?.IsAutoGeneratedFile){
      this.snackBarService.showWarning('You can not convert a subfield to a parent field in auto generated QNRs');
      return;
    }
    if (this.isManageFields) {
      return;
    }
    const parent = this.getParentNode(node);
    const grandParent = this.getParentNode(parent);
    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));
    // recursive find function to find siblings of node
    const siblings = this.findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    const nodeToInsert: FlowChartNode = siblings.splice(siblingIndex, 1)[0];

    let newParenId = '';
    if (grandParent) {
      newParenId = grandParent.item.id;
    }
    const parentSiblings = this.findNodeSiblings(changedData, parent.id);
    const parentSiblingIndex = parentSiblings.findIndex(n => n.id === parent.id);

    this.moveMoveFlowchartQuestion(nodeToInsert.id, this.section.id, newParenId, nodeToInsert.sourceSectionId, parentSiblingIndex + 1);
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.dialogService.dialogStack.length) {
      return;
    }
    if (!this.flowChartDataService.excludeHiddenQuestions) {
      this.snackBarService.showInformation('Re-ordering is disabled while excluded item are visible. Turn off \'Show Excluded Items\'');
      return;
    }
    console.log(event);
    const node: FlowChartUiFlatNode = this.treeControl.dataNodes.find(node => node.item.id == this.selectedNodeId);
    if (event.shiftKey && event.code == 'Tab' && this.flowChartControlPanel && this.flowChartControlPanel.isMoveLeft) {
      const parent = this.getParentNode(node);
      if (!parent) {
        return;
      }
      this.moveLeft(node);
    } else if (event.code == 'Tab' && this.flowChartControlPanel && this.flowChartControlPanel.isMoveRight) {
      // if(node.item.children)
      this.moveRight(node);
    }

  }


  initialize() {
    this.init();
    // if (this.flowChartDataService.isSurveyInitialized()) {
    //   this.init();
    //   return;
    // }
    // this.flowChartDataService.getQualifyingSurveyFields().pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
    //   this.init();
    // }, err => {
    //   this.init();
    // })
  }

  private init() {
    this.isManageFields = this.flowChartDataService.getIsManageFields();
    if (this.tabData && this.tabData['HasCheckbox']) {
      this.hasCheckbox = this.tabData['HasCheckbox'];
    }
    if (this.tabData && this.tabData['IsFieldSchema']) {
      this.isFieldSchema = this.tabData['IsFieldSchema'];
      this.isDragDisabled = true;
    }
    // Parse the string to json object.
    const dataObject = this.section.questions; // JSON.parse(this.TREE);

    // Build the tree nodes from Json object. The result is a list of `Node` with nested
    //     file node as children.
    const data = this.buildTree(dataObject, 0);
    if (!this.menuConfig) {
      this.menuConfig = new MenuConfig();
    } else {
      const defaultMenuConfig = new MenuConfig();
      this.menuConfig = {...defaultMenuConfig, ...this.menuConfig};
    }
    // Notify the change.
    this.dataChange.next(data);
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `Node`.
   */
  /** SHAON */
  buildTree(tree: FlowChartNode[], level: number, parentId: string = '0'): FlowChartNode[] {
    return tree.reduce<FlowChartNode[]>((accumulator, obj, idx) => {
      const node = {...obj} as FlowChartNode;

      /**
       * Make sure your node has an id so we can properly rearrange the tree during drag'n'drop.
       * By passing parentId to buildFileTree, it constructs a path of indexes which make
       * it possible find the exact sub-array that the node was grabbed from when dropped.
       */
      node.copyId = node.id;
      node.sourceSectionId = this.section.id;
      node.hasQualifyingSurvey = this.flowChartDataService.hasSurveyField(node.title);
      // node.id = `${parseInt(parentId)+1}:${idx+1}`;
      if (node.fieldValues !== null && node.fieldValues['SchemaId']) {
        node.isChecked = true;
      }

      if (obj != null) {
        if (typeof obj === 'object') {
          node.children = this.buildTree(obj.children, level + 1, node.id);
        } else {
          console.log('not a object in tree node');
        }
      }

      return accumulator.concat(node);
    }, []);
  }

  /** Add an item to to-do list */
  insertItem(parent: FlowChartNode, title: string) {

    if (parent.children) {
      const n = new FlowChartNode();
      n.title = '';
      n.isMandatory = true;
      n.fieldType = 'Yes/NO';
      n.conditionDisplayText = '(Answered)';
      n.questionDisplayId = parent.questionDisplayId + '.1';
      n.children = [];
      parent.children.push(n);
      this.dataChange.next(this.data);
    }
  }

  updateItem(node: FlowChartNode, name: string) {
    node.title = name;
    this.dataChange.next(this.data);
  }

  /** SHAON */

  ////////////////// all api call///////////

  fetchsection() {
    this.flowChartDataService.fetchSection(this.section).then(
      section => {
        this.section.questions = section.questions; /// only changed the questions reference not changing main section reference
        this.initialize();
      }
      ,
      error => {
        console.error('flowchart get sections error', error);
      }
    );
  }

  moveMoveFlowchartQuestion(questionIdToMove: string,
                            destinationSectionId: string,
                            newParentId: string,
                            sourceSectionId: string,
                            newOrder: number,
                            isFlatNewOrder: boolean = false) {

    this.flowChartDataService.MoveFlowchartQuestionCommandExecute(questionIdToMove, destinationSectionId, newParentId, sourceSectionId, newOrder, isFlatNewOrder).then(
      data => {
        this.fetchsection();
      }
      ,
      error => {
        console.error('moveMoveFlowchartQuestion error', error);
        this.fetchsection();
      }
    );
  }
  manageCountry(node: any) {
    const manageCountryPlatformCommand = new PlatformCommand('FieldSchemaManageCountryCommand', Api.Projects);
    manageCountryPlatformCommand.fieldValues['QuestionKey'] = node.item.fieldKey;
    manageCountryPlatformCommand.fieldValues['Header'] = this.section.title;
    manageCountryPlatformCommand.fieldValues['IsFieldSchema'] = this.isFieldSchema;
    manageCountryPlatformCommand.fieldValues['SchemaId'] = this.tabData['SchemaId'];
    manageCountryPlatformCommand.fieldValues['ItemId'] = this.tabData['ItemId'];
    manageCountryPlatformCommand.fieldValues['FlowChartSectionId'] = this.section.id;
    manageCountryPlatformCommand.fieldValues['NodeId'] = this.tabData['ItemId'];
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(manageCountryPlatformCommand).subscribe(response => {
        this.flowChartDataService.invalidate();
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error(error);
      });
  }
  delete(node: any) {
    if (((this.isManageFields || this.isFieldSchema) && node.item.isCustom == false) || (node.item.questionType === 'Field' && node.item.isCustom == false)) {
      this.snackBarService.showWarning('You Can Not Delete The Default Fields.');
      return;
    }
    if ((node.item.questionType === 'Field' && node.item.isCustom)) {
      const message = 'The field will be deleted permanently from the grid and form view';
      const question = 'Are you sure you want to delete this field?';
      this.dialogService.showConfirmDialog('Delete Field', 'Delete', 'Cancel', message, question).subscribe(dialogState => {
        if (dialogState.action === 'OK') {
          this.flowChartDataService.deleteFieldDefinitionCommandExecute(node, this.section).then(
            data => {
              this.fetchsection();
            }
            ,
            error => {
              console.error('deleteFieldDefinitionCommandExecute error', error);
            }
          );
        }
      });
    } else {
      const message = 'The question will be deleted permanently.';
      const question = 'Are you sure you want to delete this question?';
      this.dialogService.showConfirmDialog('Delete Field', 'Delete', 'Cancel', message, question).subscribe(dialogState => {
        if (dialogState.action === 'OK') {
          this.flowChartDataService.deleteQuestionCommandExecute(node.item.id, this.section).then(commandState => {
              if (commandState) {
                this.fetchsection();
                this.sendActivityForDeleteField(node.item);
                console.log('delete question save successfully', commandState);
              }
            },
            error => console.error('delete question question save error ', error)
          );
        }
      });

    }

  }
  private sendActivityForDeleteField(item) {
    let command = this.getActivityCommandForDeleteField(item);
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(result => {
      console.log(result);
    });
  }

  getActivityCommandForDeleteField(item) {
    let tabData = this.tabData;

    let activityCommand = new PlatformCommand("TrackActivityForQuestionnaireDesignCommand", "FileStoreApi");
    activityCommand.fieldValues['DirectoryId'] = tabData['DirectoryId'];
    activityCommand.fieldValues['ChangeFieldType'] = [];
    activityCommand.fieldValues['ChangeFieldType'].push('DeleteFieldInQnr');
    activityCommand.fieldValues['FieldHeader'] = item.title;
    activityCommand.fieldValues['ParentId'] = item.parentId;
    activityCommand.fieldValues['FlowChartSectionId'] = this.section.id;
    return activityCommand;
  }

  moveQuestionBetweenSection(node: any) {
    const dialogModel: DialogModel = DialogModel.create(
      'Move Question/Field',
      'MoveQuestionBetweenSectionDialogComponent', {...node, 'flowchartId': this.section.flowchartId},
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      if (res.action === 'OK') {
        this.flowChartDataService.moveOrCopyBetweenSectionsCommandExecute(res);
      }
    });
  }

  addSnippet(node: any, isNewSnippet: boolean, fieldType: string, snippetViewType: SnippetViewType) {
    const api = this.flowChartDataService.getApi();
    const command = new PlatformCommand('AddSnippetDialogCommand', api);
    command.fieldValues['FlowChartSectionId'] = this.section.id;
    command.fieldValues['SnippetViewType'] = snippetViewType;
    command.fieldValues['ParentId'] = this.selectedNodeId;
    command.fieldValues['IsNewSnippet'] = isNewSnippet;
    command.fieldValues['FlowchartId'] = this.section.flowchartId;
    command.fieldValues['FieldKey'] = node?.item?.fieldKey;
    command.fieldValues['FieldType'] = fieldType;
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).subscribe(response => {
      this.fetchsection();
      this.fuseSplashScreenService.hide();
    }, error => {
      this.fuseSplashScreenService.hide();
    });
    return;
  }

  addMapQuestion(node: any) {
    this.addSnippet(node, false, node?.item?.questionType, SnippetViewType.Value);
  }
  excludeQuestion(node: any) {
    this.flowChartDataService.changeQuestionVisibilityCommandExecute(node, this.section).then(
      data => {
        this.fetchsection();
      }
      ,
      error => {
        console.error('ChangeQuestionVisibilityCommand error', error);
      }
    );
  }

  openDetailsPopUp(node: any) {
    // if(this.item.cells['ViewDetailsType']){
    //   fieldDetailId = `${this.item.cells['ViewDetailsType'].value}-${fieldDef.key}`;
    // }
    let header = '';
    let details;

    if (node.item.title) {
      header = '<div style="margin-bottom: 20px;font-weight: bold;font-size: 15px;">' + node.item.title + '</div>';
    }

    if (node.item && node.item.metaData && node.item.metaData.viewDetails) {
      details = node.item.metaData.viewDetails;
    } else {
      let fieldDetailId = `${this.sourceType}-${node.item.fieldKey}`;
      fieldDetailId = fieldDetailId.toLowerCase();
      const cacheDetailsData = this.particleCacheService.getItem(fieldDetailId);
      if (cacheDetailsData && cacheDetailsData.value && cacheDetailsData.value.Details) {
        details = cacheDetailsData.value.Details;
      }
    }

    if (!details) {
      this.snackBarService.showInformation('No detail');
      return;
    }
    details = header + details;
    const dialogModel: DialogModel = DialogModel.create(
      'Details',
      'ViewDetailsComponent',
      {
        viewDetails: details
      },
      '600px',
      '700px'
    );
    dialogModel.okCaption = '';
    dialogModel.cancelCaption = '';
    this.platformSidebarStore.dispatch(
      new SetCurrentRightSideComponentAction(
        {component: 'ViewDetailComponent', data: {isUserAction: true}, componentInfo: {id: 'ViewDetailComponent'}}));
    const ViewDetailObj = details;
    this.platformSidebarStore.dispatch(new SetCurrentViewDetailAction(ViewDetailObj));
    /*this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      // console.log(res);
    });*/
  }

  editQuestion(node: FlowChartUiFlatNode) {
    /*
      edit question requirement: confirmed by shojib vai

    	          manage	survey
      custom	  yes	    yes   X
      frozen	  no	    no    X
      identity	no	    no    X
      default	  no	    yes   X
     */
    if (node.item.metaData && node.item.metaData.SnippetId) {
      this.addSnippet(node,false, 'Snippet', SnippetViewType.LiquidTemplate);
      return;
    }
    if (node.item.frozen === true && node.item.identityField === true) {
      this.snackBarService.showWarning('You Can Not Edit The Frozen Or Fields.');
      return;
    }

    if (node.item.isCustom === false && this.isManageFields === true) {
      this.snackBarService.showWarning('You Can Not Edit The Default Fields.');
      return;
    }
    this.editAddedField({
      header: node.item.title,
      instruction: node.item.instruction,
      dataType: node.item.dataType,
      isMandatory: node.item.isMandatory,
      configKey: node.item.configKey,
      Key: node.item.fieldKey,
      options: node.item.options,
      cellEditor: node.item.cellEditor,
      cellViewer: node.item.cellViewer,
      metaData: node.item.metaData,
      fieldValues: node.item.fieldValues,
      identityField: node.item.identityField,
      canFilter: node.item.canFilter
    }, false, true);
  }

  manageSubFields(node: FlowChartUiFlatNode) {
    if(node.item.dataType !== 'Number' && node.item.dataType !== 'String') {
      this.snackBarService.showInformation('This option is only available for Number or Text type field.');
    }
    let qnrDirectoryEntryId = this.tabData['DirectoryId'];
    let qnrTitle = this.tabData['QNRTitle'];
    let workbookSetId = this.tabData['WorkbookSetId'];
    let relativePath = this.tabData['RelativePath'];
    console.log('[Formula expression] : ', node.item);
    const dialogModel: DialogModel = DialogModel.create(
      `Manage Subfields`,
      'ManageSubFieldsComponent', {'formulaExpression': node.item.metaData.FormulaExpression,
        'questionTitle': node.item.title, 'fieldKey': node.item.fieldKey, 'flowchartSectionId': this.section.id,
        'flowchartId': this.flowchart.id, 'qnrDirectoryEntryId': qnrDirectoryEntryId, 'qnrTitle': qnrTitle, 'workbookSetId': workbookSetId, 'relativePath': relativePath},
      '700px',
      '700px'
    );
    dialogModel.okCaption = 'Done';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        console.log('[Formula expression] ', res);
        let formulaExpression = res.data.input.formulaExpression;
        let qnrSubFieldsResponseModel = res.data.input.qnrSubFieldsResponseModel;
        console.log('[qnrSubFieldsResponseModel]', qnrSubFieldsResponseModel);
        this.AddFormula(formulaExpression, node.item, qnrSubFieldsResponseModel, node.item.title, qnrTitle);
      }
    });

  }
  viewFormula(node: FlowChartUiFlatNode) {
    const htmlMessage = `<div class="note"><b>${node.item?.fieldValues?.FormulaExpression ?? 'No formula found.'}</b></div>`;
    const dialogModel = DialogModel.create('Formula Expression', 'ConfirmationDialogViewComponent', { message: htmlMessage });
    dialogModel.cancelCaption = null;
    dialogModel.okCaption = null;
    this.dialogService.showOkCancelDialog(dialogModel);
  }

  manageFormula(node: FlowChartUiFlatNode) {
    if (this.isFieldSchema) {
      this.fieldSchemaManageFormula(node);
      return;
    }
    const command = new PlatformCommand('ManageFormulaDialogCommand', this.flowChartDataService.getApi());
    command.setValue('FlowchartId', this.section.flowchartId);
    command.setValue('FieldTitle', node.item.title);
    command.setValue('FlowchartSectionId', node.item.sourceSectionId);
    // command.setValue('[Selected Question], ', node);
    command.setValue('SelectedQuestionId', node.id);
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState: ', response);
        this.fetchsection();
        this.fuseSplashScreenService.hide();
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error(error);
      });
  }
  fieldSchemaManageFormula(node: FlowChartUiFlatNode) {
    const command = new PlatformCommand('FieldSchemaManageFormulaCommand', Api.Projects);
    command.fieldValues['QuestionKey'] = node.item.fieldKey;
    command.fieldValues['Header'] = this.section.title;
    command.fieldValues['IsFieldSchema'] = this.isFieldSchema;
    command.fieldValues['SchemaId'] = this.tabData['SchemaId'];
    command.fieldValues['ItemId'] = this.tabData['ItemId'];
    command.fieldValues['NodeId'] = this.tabData['ItemId'];
    command.fieldValues['FlowChartSectionId'] = this.section.id;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        this.fetchsection();
        this.fuseSplashScreenService.hide();
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error(error);
      });
  }

  showFlowchartWarning() {
    const message = 'Click the \'Manage Fields\' option below where you can add new default fields for the relevant tool (e.g. DAC6 & MDR Reporter - Pre-Arrangements) inside ITP.\n';
    const question = 'Once your fields are added, you can revisit this survey template screen and switch the \'Show Excluded Items\' toggle on, where you can now choose to include your new fields in the survey template.';
    this.dialogService.showConfirmDialog('Manage Fields', 'Manage Fields', 'Cancel', message, question).subscribe(data => {
      if (data.action === 'OK') {
        this.manageSection();
      }
    });
  }

  manageSection() {
    const command = new PlatformCommand('CreateManageFieldMagicLinkCommand', this.flowChartDataService.getApi());
    command.fieldValues['SourceType'] = this.sourceType;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed to arrangement manage section', error);
      });
  }

  onExternalAdd() {
    let items: ExternalItem[];
    const api = this.flowChartDataService.getApi();
    const editFieldDetails = this.getFieldDetailsConfig(new FieldDefinition(), true, 'ADD', false);
    // isAddedAsField ? 'Add Field' : 'Add Question'
    const dialogModel: DialogModel = DialogModel.create(
      'Add External Field',
      'SelectExternalFieldComponent',
      {
        apiKey: api,
        fieldSectionId: this.section.sourceFieldSectionId,
        sourceType: this.sourceType,
        items: items,
        externalSourceType: ''
      },
      '700px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        console.log(res.data.input.items);
        const command = new PlatformCommand('AddOrUpdateExternalFieldDefinitionInFlowChartCommand', api);
        command.fieldValues['SourceFieldSectionId'] = this.section.sourceFieldSectionId;
        command.fieldValues['ExternalSourceType'] = res.data.input.externalSourceType;
        command.fieldValues['ExternalFieldDetals'] = res.data.input.items;
        command.fieldValues['FlowChartSectionId'] = this.section.id;
        command.fieldValues['IsManageFields'] = true;
        command.fieldValues['QuestionType'] = 'Field';
        command.fieldValues['ParentId'] = this.selectedNodeId;
        this.commandService.executePlatformCommand(command).subscribe(state => {
          if (state) {
            this.flowChartDataService.invalidate();
            this.fetchsection();
            this.queryState.dispatch(new GetSmartGridFieldSectionInfosAction(this.sourceType));
            this.queryState.dispatch(new GetFieldSectionsAction(this.sourceType));
          }
        });
      }
    });
  }

  onAdd(node: FlowChartUiFlatNode, isAddedAsField,activityCommandToExecute = null) {
    let isAddAsRootNode = false;
    if (node == null) {
      // node add as root
      isAddAsRootNode = true;
    }
    const editFieldDetails = this.getFieldDetailsConfig(new FieldDefinition(), isAddedAsField, 'ADD', false);
    editFieldDetails.showFieldKey = this.showFieldKey;
    if (this.isFieldSchema) {
      isAddedAsField = (this.section?.metaData?.IsQnr !== true);
      editFieldDetails.hideIsMandatoryFieldsAndCreateFieldInSourceOption = !isAddedAsField;
      editFieldDetails.fieldDefinition.isMandatory = false;
    }

    // isAddedAsField ? 'Add Field' : 'Add Question'
    const dialogModel: DialogModel = DialogModel.create(
      this.menuConfig.addField.displayText,
      'FieldEditorDialogComponent', {'editFieldDetails': editFieldDetails, 'fieldValues': this.flowChartDataService.fieldValues},
      '700px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res && res.action === 'OK') {
        // res.data.input.editFieldDetails.fieldDefinition.order = this.getFieldToAddOrder(res.data.input.editFieldDetails.selectedSection);
        // this.addedFieldSection = res.data.input.editFieldDetails.selectedSection; // added field section
        let createFieldInSource = false;
        if (res.data.input.editFieldDetails.createFieldInSource) {
          createFieldInSource = res.data.input.editFieldDetails.createFieldInSource;
        }
        if (isAddedAsField) {
          this.lastAddedFieldKey = res.data.input.editFieldDetails.fieldDefinition.key;
          this.addOrUpdateFieldDefinition(res.data.input.editFieldDetails.fieldDefinition, 'Field', 'ADD', isAddAsRootNode);
        } else {
          this.addOrUpdateFieldDefinition(res.data.input.editFieldDetails.fieldDefinition, 'Question', 'ADD', isAddAsRootNode, createFieldInSource);
        }
        if(this.tabData){
          let activityCommandToExecute = this.getActivityCommandForAddField(res);
          this.commandService.executePlatformCommand(activityCommandToExecute).pipe(take(1)).subscribe(response => {
            console.log(response);
          });
        }
      }
    });
  }
  getActivityCommandForAddField(res) {
    let tabData = this.tabData;
    let fieldDefinition = res.data.input.editFieldDetails.fieldDefinition;
    let activityCommand = new PlatformCommand("TrackActivityForQuestionnaireDesignCommand", "FileStoreApi");
    activityCommand.fieldValues['DirectoryId'] = tabData['DirectoryId'];
    activityCommand.fieldValues['ChangeFieldType'] = [];
    activityCommand.fieldValues['ChangeFieldType'].push('AddFieldInQnr');
    activityCommand.fieldValues['FieldHeader'] = fieldDefinition?.header;
    if(fieldDefinition.isMandatory){
      activityCommand.fieldValues['FieldStatus'] = 'mandatory';
    } else{
      activityCommand.fieldValues['FieldStatus'] = 'optional';
    }

    return activityCommand;
  }

  private getFieldDetailsConfig(fieldDefinition: any, isAddedAsField: boolean, actionMode: string, isCustomEditQuestion: boolean) {
    console.log('field definition:', fieldDefinition);
    const fieldDetails = new FieldEditorDialogModel();
    fieldDetails.sourceType = this.sourceType;
    if (actionMode === 'ADD') {
      fieldDefinition.key = Guid.create().toString();
      fieldDetails.fieldDefinition = fieldDefinition;
      // fieldDetails.selectedSection = JSON.parse(JSON.stringify({id: this.section.sourceFieldSectionId}));
      fieldDetails.hideSettings = true;
    } else if (actionMode === 'EDIT') {
      let fieldSettings = null;
      if (!isCustomEditQuestion) {
        if (fieldDefinition.configKey) {
          const fieldConfig = Configuration.getSmartGridConfig(fieldDefinition.configKey);
          if (fieldConfig && fieldConfig.FieldSettings) {
            fieldSettings = fieldConfig.FieldSettings;
          }
        }
        if (!fieldSettings || !fieldDefinition.configKey) {
          return null; // no options thats why return
        }
        fieldDetails.showSettingsPageFirst = true;
      } else {
        fieldDetails.showSettingsPageFirst = false;
      }

      fieldDetails.fieldDefinition = JSON.parse(JSON.stringify(fieldDefinition)); // copy field definition
      // fieldDetails.selectedSection = JSON.parse(JSON.stringify({id: this.section.sourceFieldSectionId}));
      fieldDetails.hideSettings = false;
      // if (this.addedFieldSection && this.addedFieldSection.id && this.section.sourceFieldSectionId && this.section.sourceFieldSectionId !== this.addedFieldSection.id) {
      //   fieldDetails.selectedSection = JSON.parse(JSON.stringify({id: this.section.sourceFieldSectionId}));
      // }
      fieldDetails.disableDataTypeEdit = true;
    }
    fieldDetails.section = this.section;
    fieldDetails.clientConfig = this.sourceType;
    // editFieldDetails.isSectionNotRequired = true;
    fieldDetails.fieldNameTitle = isAddedAsField ? 'Field Name' : 'Field Name';
    fieldDetails.fieldDetailsTitle = isAddedAsField ? 'Field Details' : 'Question Details';
    fieldDetails.fieldTypeTitle = isAddedAsField ? 'Field Type' : 'Field Type';
    fieldDetails.fieldTypePlaceHolder = isAddedAsField ? 'select a field type' : 'select a field type';
    fieldDetails.editOrAddSectionAllowed = false;
    fieldDetails.actionMode = actionMode;
    fieldDetails.customDataTypes = this.flowChartDataService.getCustomDataTypes(this.sourceType);
    return fieldDetails;
  }

  editAddedField(fieldDefinition: any, isAddedAsField: boolean, isCustomEditQuestion: boolean = false) {
    const editFieldDetails = this.getFieldDetailsConfig(fieldDefinition, isAddedAsField, 'EDIT', isCustomEditQuestion);
    let previousFieldDefinitions = {...editFieldDetails.fieldDefinition};
    if (editFieldDetails == null) {
      return;
    } // means fieldDefinition saved as primitive it has no option types
    editFieldDetails.showFieldKey = this.showFieldKey;
    const dialogModel: DialogModel = DialogModel.create(
      `Edit Field ${editFieldDetails.fieldDefinition && editFieldDetails.fieldDefinition.header ? ' (' + editFieldDetails.fieldDefinition.header + ')' : ''}`,
      'FieldEditorDialogComponent', {'editFieldDetails': editFieldDetails, 'fieldValues': this.flowChartDataService.fieldValues},
      '700px',
      '700px'
    );
    if (fieldDefinition.metaData) {
      if (fieldDefinition.metaData.hasOwnProperty('IsAddOptionDisabled')) {
        // metadata in question is treated as string value
        dialogModel.input.isAddOptionDisabled = fieldDefinition.metaData['IsAddOptionDisabled'] ? fieldDefinition.metaData['IsAddOptionDisabled'].toLowerCase() === 'true' : false;
      }
    }
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        if (isAddedAsField) {
          this.addOrUpdateFieldDefinition(res.data.input.editFieldDetails.fieldDefinition, 'Field', 'UPDATE');
        } else {
          this.addOrUpdateFieldDefinition(res.data.input.editFieldDetails.fieldDefinition, 'Question', 'UPDATE');
        }
        if(this.tabData){
          let activityCommand = this.getActivityCommandForEditField(previousFieldDefinitions,res.data.input.editFieldDetails.fieldDefinition);
          this.commandService.executePlatformCommand(activityCommand).pipe(take(1)).subscribe(response => {
            console.log(response);
          });
        }
      }
    });
  }


  getActivityCommandForEditField(previousFieldDefinition,fieldDefinition) {
    let tabData = this.tabData;
    let previousDescription = previousFieldDefinition.instruction;
    let previousStatus = previousFieldDefinition.isMandatory;
    let currentFieldDescription = fieldDefinition.instruction;
    let currentFieldStatus = fieldDefinition.isMandatory;

    let activityCommand = new PlatformCommand("TrackActivityForQuestionnaireDesignCommand", "FileStoreApi");
    activityCommand.fieldValues['DirectoryId'] = tabData['DirectoryId'];
    activityCommand.fieldValues['ChangeFieldType'] = [];
    activityCommand.fieldValues['ChangeFieldType'].push('EditFieldInQnr');
    if(currentFieldStatus !== previousStatus){
      activityCommand.fieldValues['NewFieldStatus'] = currentFieldStatus?'mandatory' : 'optional';
    }
    if(currentFieldDescription !== previousDescription){
      activityCommand.fieldValues['IsDescriptionChanged'] = true;
    }
    activityCommand.fieldValues['FieldHeader'] = fieldDefinition.header;
    return activityCommand;
  }

  addOrUpdateFieldDefinition(fieldDefinition: any, questionType: string, actionMode: string,
                             isAddAsRootNode: boolean = false, createFieldInSource: boolean = false) {
    this.flowChartDataService.addOrUpdateFieldDefinitionInFlowChartCommandExecute(fieldDefinition, questionType,
      actionMode, this.section, isAddAsRootNode ? '' : this.selectedNodeId, createFieldInSource).then(
      data => {
        this.fetchsection();
        if (data.actionMode === 'ADD') {
          // because after field add it need to update options if it have
          this.editAddedField(data.fieldValues['FieldDefinition'], true);
        } else if (data.actionMode === 'UPDATE') {
          this.flowChartDataService.invalidate(); // same field multiple section needs to refresh
        }
        console.log('addOrUpdateFieldDefinition save successfully', data);
      }
      ,
      error => {
        console.error('addOrUpdateFieldDefinition error', error);
      }
    );
  }

  addCondition(node: FlowChartUiFlatNode, title?) {
    let defaultSelectedIndex = 0;
    let defaultSelectedFieldKey = null;
    if (node.item.visibilityLogicGate && node.item.visibilityLogicGate.fieldLogicGates && node.item.visibilityLogicGate.fieldLogicGates.length > 0) {
      defaultSelectedIndex = this.getAutoSelectedQuestionIndex(node.item.visibilityLogicGate.fieldLogicGates[0].fieldKey, node);
      defaultSelectedFieldKey = node.item.visibilityLogicGate.fieldLogicGates[0].fieldKey;
    } else {
      defaultSelectedIndex = this.getAutoSelectedQuestionIndex(null, node);
    }


    const dialogModel: DialogModel = DialogModel.create(
      title,
      'AddConditonComponent', JSON.parse(JSON.stringify({
        node: node,
        visibilityLogicGate: node.item.visibilityLogicGate,
        defaultSelectedQuestion: defaultSelectedIndex < 0 ? null : this.treeControl.dataNodes[defaultSelectedIndex],
        defaultSelectedIndex: defaultSelectedIndex,
        defaultSelectedFieldKey: defaultSelectedFieldKey,
        questions: [].concat(this.treeControl.dataNodes.filter(x => x.id !== node.id).filter((y) => y.item.isHidden === false)),
        flowchartId: this.section.flowchartId,
        isAllAlwaysHidden:true,
      })),
      '1000px',
      '1000px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      if (res && res.action === 'OK') {
        this.flowChartDataService.changeVisibilityLogicGateCommandExecute(node, res, this.section).then(
          data => {
            this.sendActivityForAddConditionInField(res);
            this.fetchsection();
          }
          ,
          error => {
            console.error('ChangeVisibilityLogicGateCommand error', error);
          }
        );

      }
    });

  }

  private sendActivityForAddConditionInField(res: any) {
    const item = res.data.input.node.item;
    const conditionText = res.data.input.visibilityLogicGate.toolTip;
    let command = this.getActivityCommandForAddCondition(item, conditionText);
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(result => {
      console.log(result);
    });
  }

  getActivityCommandForAddCondition(item, conditionText) {
    const tabData = this.tabData;

    const activityCommand = new PlatformCommand('TrackActivityForQuestionnaireDesignCommand', 'FileStoreApi');
    if (tabData) {
      activityCommand.fieldValues['DirectoryId'] = tabData['DirectoryId'];
    }
    activityCommand.fieldValues['ChangeFieldType'] = [];
    activityCommand.fieldValues['ChangeFieldType'].push('AddConditionInFieldInQnr');
    activityCommand.fieldValues['FieldHeader'] = item.title;
    activityCommand.fieldValues['ConditionContext'] = conditionText;
    return activityCommand;
  }

  getFieldToAddOrder(fieldSection) {
    const selectedFieldSection = this.flowChartDataService.getFlowchartSectionsByFlowchartId(this.section.flowchartId).find(section => section.id === fieldSection.id);
    let fieldDefCount = 0;
    if (selectedFieldSection && selectedFieldSection.fieldGroups) {
      fieldDefCount = selectedFieldSection.fieldGroups.length;
    }
    if (selectedFieldSection && selectedFieldSection.fieldDefinitions) {
      fieldDefCount = Math.max(fieldDefCount, selectedFieldSection.fieldDefinitions.length);
    }
    if (selectedFieldSection && selectedFieldSection.sectionFieldDefinitions) {
      fieldDefCount = Math.max(fieldDefCount, selectedFieldSection.sectionFieldDefinitions.length);
    }
    return fieldDefCount;
  }

  closeRightSidebar() {
    if (this.sidebarService.getSidebar('rightsidebar')) {
      this.sidebarService.getSidebar('rightsidebar').close();
      this.sidebarService.getSidebar('rightsidebar').fold();
    }
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction(null));
    this.platformSidebarStore.dispatch(new SetCurrentRightSideBarFoldOrNotAction(true));
  }

  onEditDetailsAndInstructions(node: any) {
    if (this.isManageFields) {
      this.detailsInstructionService.openDetailsInstructionPopUp(InstructionDetailsSourceViewType.flowchart, this.sourceType, node.item.fieldKey);
    } else {
      let actualSourceType = this.flowchart.sourceType;
      if (actualSourceType === 'Flow') {
        actualSourceType = this.flowchart.id;
      }
      this.detailsInstructionService.openDetailsInstructionPopUp(InstructionDetailsSourceViewType.flowchart, actualSourceType, node.item.fieldKey, null, null, this.flowchart.surveyId, node.item.title);
    }
  }

  private AddFormula(formulaExpression: any, question: any, qnrSubFieldsResponseModel: any, questionTitle: string, qnrTitle: string) {
    console.log('[Add formula for Question]', question, this.flowChartDataService.flowchartId);
    const platformCommand = new PlatformCommand('ExecuteSubFieldsForQuestionCommand', Api.FileStoreApi);
    platformCommand.fieldValues['FlowChartId'] = this.section.flowchartId;
    platformCommand.fieldValues['FlowChartSectionId'] = this.section.id;
    platformCommand.fieldValues['QuestionKey'] = question.fieldKey;
    platformCommand.fieldValues['QuestionnaireSubFieldsConfigurationModel'] = qnrSubFieldsResponseModel;
    platformCommand.fieldValues['QuestionTitle'] = questionTitle;
    platformCommand.fieldValues['QuestionnaireName'] = qnrTitle;

    console.log(platformCommand);
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      this.queryState.dispatch(new GetSmartGridFieldSectionInfosAction(this.sourceType));
      this.queryState.dispatch(new GetFieldSectionsAction(this.sourceType));
      this.flowChartDataService.invalidate();
    });
  }

  private updateChecklist(question: any, isChecked: boolean) {
    const platformCommand = new PlatformCommand('UpdateFieldSchemaChecklistCommand', Api.Projects);
    platformCommand.fieldValues['FlowChartId'] = this.section.flowchartId;
    platformCommand.fieldValues['FlowChartSectionId'] = this.section.id;
    platformCommand.fieldValues['FieldKey'] = question.fieldKey;
    platformCommand.fieldValues['ParentId'] = question.parentId;
    platformCommand.fieldValues['SchemaId'] = this.tabData['SchemaId'];
    platformCommand.fieldValues['ItemId'] = this.tabData['ItemId'];
    platformCommand.fieldValues['IsChecked'] = isChecked;
    platformCommand.fieldValues['NodeId'] = this.tabData['ItemId'];

    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      this.flowChartDataService.invalidate();
      this.flowChartDataService.invalidateGridDataIfNeeded();
    });
  }

  IsDataTypeNumberOrPercentage(node: any) {
    return node.item.dataType === 'Number' || node.item.dataType === 'Percentage';
  }
  askXatBot(node: any) {
    this.xatBotThreadService.askXatBot(this.flowchart.id, this.tabData["SurveyFlowchartSectionId"], node);
  }
}
